import React, { useEffect, useState } from 'react';
import { getProductosbyEmpleado, getEmpleados, getTipoIncidentes } from "../api";
import jsPDF from "jspdf";
import logoData from './logo.json';
import autoTable from "jspdf-autotable";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

const ReporteEspecificoEmpleado = () => {
  const [empleados, setEmpleados] = useState([]);
  const [reporte, setReporte] = useState({});
  const [formData, setFormData] = useState({ id_empleado: '' });
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  const colores = ['#348feb', '#82ca9d', '#ffc658', '#ff6b6b'];

  useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = async () => {
    try {
      const [empleadosResponse, tipoIncidentesResponse] = await Promise.all([
        getEmpleados(),
        getTipoIncidentes()
      ]);
      setEmpleados(empleadosResponse.data);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const obtenerReporte = async () => {
    setCargando(true);
    setError(null);

    try {
      const response = await getProductosbyEmpleado(formData.id_empleado);
      const data = response.data;

      const agrupado = {};
      data.forEach((incidente, i) => {
        agrupado[`${i + 1}. ${incidente.incidente_descripcion}`] = incidente.productos.map((p, j) => ({
          id: j + 1,
          codigo: p.codigo,
          descripcion: p.descripcion,
          estado: p.estado,
          creado_por: incidente.empleado,
          fecha_creacion: p.fecha_prestamo,
          fecha_cierre: p.fecha_cierre
        }));
      });

      setReporte(agrupado);
    } catch (err) {
      console.error('❌ Error al obtener el reporte:', err);
      setError('Error al obtener el reporte');
    } finally {
      setCargando(false);
    }
  };

  const agruparPorEstado = (productos) => {
    const conteo = {};
    productos.forEach(p => {
      conteo[p.estado] = (conteo[p.estado] || 0) + 1;
    });
    return Object.entries(conteo).map(([estado, cantidad]) => ({
      name: estado,
      value: cantidad
    }));
  };

  const generarPDF = () => {
    const doc = new jsPDF();
    let y = 10;

    const fecha = new Date();
    const mes = fecha.toLocaleString('default', { month: 'long' });
    const anio = fecha.getFullYear();

    // 👉 LOGO
    doc.addImage(logoData.base64, 'PNG', 150, 8, 50, 15);

    doc.setFontSize(13);
    doc.text(`Reporte de Productos`, 10, y);
    y += 10;

    Object.entries(reporte).forEach(([categoria, productos]) => {
      doc.setFontSize(9);
      doc.text(categoria, 10, y);
      y += 5;

      const data = productos.map((p) => [
        p.id,
        p.codigo,
        p.descripcion,
        p.estado,
        p.creado_por,
        p.fecha_creacion,
        p.fecha_cierre === '1990-01-01 00:00:00' ? '—' : p.fecha_cierre
      ]);

      autoTable(doc, {
        head: [["#", "Código", "Descripción", "Estado", "Solicitante", "Fecha préstamo", "Fecha cierre"]],
        body: data,
        startY: y,
        theme: "striped",
        styles: { fontSize: 7 },
        margin: { left: 10, right: 10 },
        headStyles: { fillColor: [12, 64, 104] },
        didDrawPage: (data) => {
          y = data.cursor.y + 10;
        },
      });

      if (y > 270) {
        doc.addPage();
        y = 10;
      }
    });

    doc.save(`reporte-${mes}-${anio}.pdf`);
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Reporte por Empleado</h2>

      <label className="label2">Personal</label>
      <select
        name="id_empleado"
        value={formData.id_empleado}
        onChange={handleChange}
        className="input-form-1"
      >
        <option value="">Seleccione un empleado</option>
        {empleados.map((empleado) => (
          <option key={empleado.id} value={empleado.id}>
            {empleado.nombres} {empleado.apellido_paterno}
          </option>
        ))}
      </select>

      <button onClick={obtenerReporte} className="button-form-blue mt-2">
        Consultar reporte
      </button>

      {cargando && <p className="text-gray-600 mt-4">Cargando reporte...</p>}
      {error && <p className="text-red-500 mt-4">Error: {error}</p>}

      {!cargando && !error && Object.keys(reporte).length > 0 && (
        <>
          <button onClick={generarPDF} className="button-form-gray mt-4">
            Descargar PDF
          </button>

          {Object.entries(reporte).map(([categoria, productos], idx) => (
            <div key={categoria} className="mb-10">
              <h3 className="text-xl font-semibold mt-6 mb-2">{categoria}</h3>
              <p className="mb-4">
                Total de productos: <strong>{productos.length}</strong>
              </p>

              <ResponsiveContainer width="100%" height={250}>
                <PieChart>
                  <Pie
                    data={agruparPorEstado(productos)}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    fill="#348feb"
                    label
                  >
                    {agruparPorEstado(productos).map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={colores[index % colores.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend verticalAlign="bottom" height={36} />
                </PieChart>
              </ResponsiveContainer>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default ReporteEspecificoEmpleado;
